export default "__VITE_PUBLIC_ASSET__f9fd4eb4__"